import React from 'react';
import PropTypes from 'prop-types';

const LinterDrawerContext = React.createContext(undefined);

// Actions
const OPEN_LINTER_DRAWER = 'open-linter-drawer';
const CLOSE_LINTER_DRAWER = 'close-linter-drawer';

const init = () => {
  return {
    linterResults: null,
    isOpen: false,
  };
};

// Reducer
const reducer = (state, action) => {
  switch (action.type) {
    case OPEN_LINTER_DRAWER: {
      return {
        ...state,
        isOpen: true,
        linterResults: action.linterResults,
      };
    }
    case CLOSE_LINTER_DRAWER: {
      return {
        ...state,
        isOpen: false,
      };
    }
    default: {
      throw new Error(
        `Unhandled ScenarioChartContext action type: ${action.type}`,
      );
    }
  }
};

const LinterDrawerProvider = ({
  children,
}) => {
  const [state, dispatch] = React.useReducer(reducer, null, init);

  const openLinterDrawer = (linterResults) => {
    dispatch({ type: OPEN_LINTER_DRAWER, linterResults });
  };
  const closeLinterDrawer = (onClose = () => {}) => {
    onClose();
    dispatch({ type: CLOSE_LINTER_DRAWER });
  };

  const memoizedValue = React.useMemo(() => {
    return {
      isOpen: state.isOpen,
      linterResults: state.linterResults,
      openLinterDrawer,
      closeLinterDrawer,
    };
  }, [
    state,
    openLinterDrawer,
    closeLinterDrawer,
  ]);

  return (
    <LinterDrawerContext.Provider value={memoizedValue}>
      {children}
    </LinterDrawerContext.Provider>
  );
};

const useLinterDrawerContext = () => {
  const context = React.useContext(LinterDrawerContext);
  if (context === undefined) {
    throw new Error(
      'useLinterDrawerContext must be used within a LinterDrawerProvider',
    );
  }
  return context;
};

LinterDrawerProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

export { LinterDrawerProvider, useLinterDrawerContext };
